import { apiSlice } from '../../api/api';

export const subscriptionApi = apiSlice.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getSubscription: builder.query({
            query: () => ({
                url: '/operations/subscription/records',
                method: 'GET',
            }),
            providesTags: ['Subscription'],
        }),
    }),
});

export const { useGetSubscriptionQuery } = subscriptionApi;